import React, { forwardRef } from 'react';

import { Stack } from '@mui/material';

import { DynamicSectionType } from '../../context/useDynamicSections';

import ScheduleContentBannerImageInput, { getBannerId } from './Inputs/ScheduleContentBannerImageInput';

interface Props {
  existingBannerId?: string;
  brand: string;
}

enum BRAZE_BANNER_INPUT_NAMES {
  BANNER_IMAGE_ID = 'braze_banner_image_id',
}

export function parseBrazeBannerFormData(formData: FormData, position = -1) {
  return {
    brazeBannerId: getBannerId(String(formData.get(BRAZE_BANNER_INPUT_NAMES.BANNER_IMAGE_ID))),
    position,
    type: DynamicSectionType.BRAZE_BANNER,
  };
}

const BrazeBannerSectionForm = forwardRef<HTMLFormElement, Props>((props, ref) => {
  const { existingBannerId, brand } = props;

  return (
    <Stack component="form" ref={ref} direction="column" gap={2}>
      <ScheduleContentBannerImageInput
        name={BRAZE_BANNER_INPUT_NAMES.BANNER_IMAGE_ID}
        initialBannerId={existingBannerId}
        label="Braze Article/Banner Id"
        brand={brand}
      />
    </Stack>
  );
});

BrazeBannerSectionForm.displayName = 'BrazeBannerSectionForm';

export default BrazeBannerSectionForm;
